export default __webpack_public_path__ + "static/media/Version (1) - Hobbit - Thumbnail.ed71e0d9.png";